import * as React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { withUser } from '../services/withUser';

const privateRender = (Component: any, loggedIn: boolean) => (props: any) =>
  loggedIn ? (
    <Component {...props} />
  ) : (
    <Redirect
      to={{
        pathname: '/login',
        state: { from: props.location }
      }}
    />
  );

const PrivateRoute = ({ component: Component, user, ...rest }: any) => (
  <Route {...rest} render={privateRender(Component, user.loggedIn)} />
);

export default withUser(PrivateRoute);



// WEBPACK FOOTER //
// ./src/components/PrivateRoute.tsx